import { useSelector } from 'react-redux';
import React from 'react';

import ContactInfoEdit from './editContactInfo';
import ContainerSectionMobile from '../../components/containerSectionMobile';
import ContainerSectionDesktop from '../../components/containerSectionDesktop';

import './contactInfoScreen.scss';

const ContactInfoEditScreen = () => {
  const isMobileDevice = useSelector((state) => state.mediaQuery.isMobileDevice);

  return (
    isMobileDevice ? (
      <ContainerSectionMobile className="profile-information">
        <ContactInfoEdit />
      </ContainerSectionMobile>
    ) : (
      <ContainerSectionDesktop>
        <ContactInfoEdit />
      </ContainerSectionDesktop>
    )
  );
};

export default ContactInfoEditScreen;
